import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
} from '@mui/material';
import {
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationOnIcon,
  AccessTime as AccessTimeIcon,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const ContactSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

const Contacts: React.FC = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Контакты
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <ContactSection>
            <Typography variant="h5" gutterBottom>
              Наши контакты
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <EmailIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Email" 
                  secondary="tyumen-science@yandex.ru" 
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemIcon>
                  <PhoneIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Телефон" 
                  secondary="+7(912)995-75-35" 
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemIcon>
                  <LocationOnIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Адрес" 
                  secondary="г.Тюмень, ул.Одесская, д.9, оф.511, 625023" 
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemIcon>
                  <AccessTimeIcon color="primary" />
                </ListItemIcon>
                <ListItemText 
                  primary="Режим работы" 
                  secondary="Пн-Пт, 9:00 - 18:00" 
                />
              </ListItem>
            </List>
          </ContactSection>
        </Grid>

        <Grid item xs={12} md={6}>
          <ContactSection>
            <Typography variant="h5" gutterBottom>
              Как нас найти
            </Typography>
            <Box sx={{ height: 400, bgcolor: 'grey.200', mb: 2 }}>
              {/* Здесь можно добавить карту */}
              <Typography variant="body1" align="center" sx={{ py: 20 }}>
                Карта будет добавлена позже
              </Typography>
            </Box>
            <Typography variant="body1" paragraph>
              Мы находимся в центре города, в шаговой доступности от основных транспортных узлов.
            </Typography>
          </ContactSection>
        </Grid>

        <Grid item xs={12}>
          <ContactSection>
            <Typography variant="h5" gutterBottom>
              Связаться с нами
            </Typography>
            <Typography variant="body1" paragraph>
              Если у вас есть вопросы по публикации статей, сотрудничеству или другим вопросам,
              вы можете связаться с нами любым удобным способом:
            </Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="По вопросам публикации статей" 
                  secondary="tyumen-science@yandex.ru" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="По вопросам сотрудничества" 
                  secondary="tyumen-science@yandex.ru" 
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="По техническим вопросам" 
                  secondary="tyumen-science@yandex.ru" 
                />
              </ListItem>
            </List>
          </ContactSection>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Contacts; 